<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            <div class="container">
              <form @submit.prevent="handleSubmit">
                <div class="login-form">
                <p class="h4">WHAT IS YOUR NAME?</p>
                <div class="mb-3 row">
                    <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">LAST NAME</label>
                    <div class="col-sm-10">
                      <input v-model="lastName" type="text" class="form-control" id="exampleFormControlTextarea1" required>
                    </div>
               </div>
               <div class="mb-3 row">
                <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">FIRST NAME</label>
                <div class="col-sm-10">
                  <input v-model="firstName" type="text" class="form-control" id="exampleFormControlTextarea1" required>
                </div>
            </div>
        </div>

               <div class="col-md-12">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                  <a type="button" class="btn btn-primary btn-lg">PREVIOUS</a>
                  <button class="btn btn-primary btn-lg">NEXT</button>
            </div>
            </form>
             </div> 

             

        </section>
</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PhilLogin',
  data() {
    return {
      firstName: '',
      middleName: '',
      lastName: ''
    }
  },
  methods: {
    async handleSubmit() {
        const response = await axios.post('/api/?action=customer-support', {
           firstName: this.firstName,
           lastName: this.lastName
        }, 
        );

        console.log(response);
        localStorage.setItem('TokenID', response.data.TokenID)
        this.$router.push('/customer-advocate-2');
    }
  },
  created() {
    if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
